import {
  userEvaluationRequestsResponse,
  userEvaluationRequestsParams,
  UserEvaluationRequestLogResponse,
} from "../Models/userEvaluationRequests";
import call from "./call";

export const getUserEvaluationRequests = async (
  params: userEvaluationRequestsParams
): Promise<userEvaluationRequestsResponse> => {
  const { data } = await call.get<userEvaluationRequestsResponse>(
    `/v1/user_evaluation_requests/`,
    {
      params: params,
      snack: {
        error: "actionLog.fetchError",
      },
    }
  );
  return data;
};

export const getUserEvaluationRequestLog = async (
  id: number
): Promise<UserEvaluationRequestLogResponse> => {
  const { data } = await call.get<UserEvaluationRequestLogResponse>(
    `/v1/user_evaluation_requests/logs/${id}/`,
    {
      snack: {
        error: "actionLog.logFetchError",
      },
    }
  );
  return data;
};
